import { Component, OnInit, Renderer2, OnDestroy } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "firebase";
import { Store } from "@ngrx/store";
import { AnimationOptions } from "ngx-lottie";
import { SetOnBoarding } from "@edp-store/actions/user.actions";

@Component({
  selector: "edp-onboarding",
  templateUrl: "./edp-onboarding.component.html",
  styleUrls: ["./edp-onboarding.component.scss"]
})
export class EdpOnboardingComponent implements OnInit, OnDestroy {
    public translateValue = 0;
    public currentPosition = 0;
    public $user: Observable<User>;

    public options: AnimationOptions = {
        path: "/assets/images/onboarding/onboarding-step1.json",
        loop: false,
    };

    public optionsMobile: AnimationOptions = {
        path: "/assets/images/onboarding/onboarding-step1-mobile.json",
        loop: false,
    };

    public itemList = [
        {
            title: "A ÁREA DE CLIENTE MUDOU",
            description: "Descubra todas as novidades que temos para si",
            animation: "/assets/images/onboarding/onboarding-step1.json",
        },
        {
            title: "NOVA VISÃO DO SEU CONTRATO",
            description: "Veja a informação mais relevante do seu contrato, consulte as suas faturas e pagamentos e envie leituras num só ecrã.",
            image: "assets/images/onboarding/01-slide.png",
        },
        {
            title: "SIMULE A PRÓXIMA FATURA",
            description: "Envie a sua leitura e tenha imediatamente uma previsão de quanto vai pagar na próxima fatura.",
            image: "assets/images/onboarding/02-slide.png",
        },
        {
            title: "CONTROLE A SUA CONTA CERTA",
            description: "Se tiver Conta Certa, decida quanto quer pagar todos os meses e receba alertas quando consumir acima do valor da mensalidade.",
            image: "assets/images/onboarding/03-slide.png",
        },
        {
            title: "ACESSO A VANTAGENS EXCLUSIVAS",
            description: "Peça todos os descontos exclusivos e códigos promocionais na sua área de cliente.",
            image: "assets/images/onboarding/04-slide.png",
        },
        {
            icon: "icon-edponline-BraEO-021",
            description: "Descubra já as novas funcionalidades.",
            button: {
                label: "DESCOBRIR",
                action: () => this.close(),
            },
        },
    ];

    public itemListMobile = [
        {
            title: "A ÁREA DE CLIENTE MUDOU",
            description: "Descubra todas as novidades que temos para si",
            animation: "/assets/images/onboarding/onboarding-step1-mobile.json",
        },
        {
            title: "NOVA VISÃO DO SEU CONTRATO",
            description: "Veja a informação mais relevante do seu contrato, consulte as suas faturas e pagamentos e envie leituras num só ecrã.",
            image: "assets/images/onboarding/01-slide-mobile.png",
        },
        {
            title: "SIMULE A PRÓXIMA FATURA",
            description: "Envie a sua leitura e tenha imediatamente uma previsão de quanto vai pagar na próxima fatura.",
            image: "assets/images/onboarding/02-slide-mobile.png",
        },
        {
            title: "CONTROLE A SUA CONTA CERTA",
            description: "Se tiver Conta Certa, decida quanto quer pagar todos os meses e receba alertas quando consumir acima do valor da mensalidade.",
            image: "assets/images/onboarding/03-slide-mobile.png",
        },
        {
            title: "ACESSO A VANTAGENS EXCLUSIVAS",
            description: "Peça todos os descontos exclusivos e códigos promocionais na sua área de cliente.",
            image: "assets/images/onboarding/04-slide-mobile.png",
        },
        {
            icon: "icon-edponline-BraEO-021",
            description: "Descubra já as novas funcionalidades.",
            button: {
                label: "DESCOBRIR",
                action: () => this.close(),
            },
        },
    ];
    constructor(
        private store: Store,
        private renderer: Renderer2) { }

    ngOnInit() {
        this.renderer.addClass(document.body, "overflow-hidden");
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, "overflow-hidden");
    }

    public slideLeft(): void {
        if (this.currentPosition > 0) {
            --this.currentPosition;
            this.translateValue += 100;
        }
    }

    public slideRight(): void {
        if (this.currentPosition < 6) {
            ++this.currentPosition;
            this.translateValue -= 100;
        }
    }

    public goToSlide(position): void {
        this.currentPosition = position;
        this.translateValue = position * -100;
    }

    public close(): void {
        this.store.dispatch(new SetOnBoarding(false));
        localStorage.setItem("user-onboarding", "false");
    }
}
